import React from "react"
import classnames from "classnames"
import styles from "./FormGroup.less"

class FormGroup extends React.PureComponent {
  render() {
    const {
      children,
      radio = false,
      hide = false,
      show = false,
      checkbox = false,
      center = false
    } = this.props
    return (
      <div
        className={classnames({
          [styles.FormGroup]: true,
          [styles.FormGroupHide]: !show && hide,
          [styles.FormGroupRadio]: show && radio,
          [styles.FormGroupCheckbox]: show && checkbox,
          [styles.FormGroupShow]: show,
          [styles.FormGroupCenter]: center
        })}>
        {children}
      </div>
    )
  }
}


export default FormGroup



// WEBPACK FOOTER //
// ./src/AtomicComponents/FormGroup/FormGroup.jsx